import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FilePdfIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 3V7C13 8.105 13.895 9 15 9H19M13 3H7C5.895 3 5 3.895 5 5V19C5 20.105 5.895 21 7 21H17C18.105 21 19 20.105 19 19V8.414C19 8.149 18.895 7.895 18.707 7.707L14.293 3.293C14.105 3.105 13.851 3 13.586 3H13ZM8 13H10C10.552 13 11 13.448 11 14V14C11 14.552 10.552 15 10 15H8V13ZM8 13V17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

FilePdfIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FilePdfIcon);
